import React, { useState } from "react";
import ToggleButtons from "../buttons/ToggleButtons";
import ApplicationStatusBar from "../applications/ApplicationStatusBar";
import { ApplicantResultSummary } from "../applications/ApplicantResultSummary";

const TABS = [
  {
    id: "checklist",
    icon: "file-earmark-richtext",
    label: "Required Docs",
  },
  {
    id: "summary",
    icon: "shield-check",
    label: "Summary",
  },
  {
    id: "messages",
    icon: "chat-left-text",
    label: "Messages",
  },
];

const ApplicationInfoCard = () => {
  const [activeTab, setActiveTab] = useState(TABS[0]);

  return (
    <div className="card custom-card">
      <div className="card-header">
        <ToggleButtons
          defaultActive={0}
          buttons={TABS}
          onClick={(e, tab) => setActiveTab(tab)}
        />
      </div>
      <div className="card-body">
        {activeTab?.id === "checklist" && <CheckListTab />}
        {activeTab?.id === "summary" && <SummaryTab />}
        {activeTab?.id === "messages" && <MessagesTab />}
      </div>
    </div>
  );
};

const SummaryTab = () => {
  return (
    <div>
      <ApplicantResultSummary applicant={{
        name: 'Andrew Allen ',
        primary: true,
        guarantor: false
      }} />
      <ApplicantResultSummary applicant={{
        name: 'Daniel Ramirez',
        primary: false,
        guarantor: true
      }} />
      <ApplicantResultSummary applicant={{
        name: 'Lukas Marmanis',
        primary: false,
        guarantor: false,
      }} />
    </div>
  );
};




const CheckListTab = () => {
  return (
    <div>
      <ApplicationStatusBar status="docs_received" variant="success" />

      <div className="alert alert-success text-dark">
        <div className="mb-2">
          <span className="fw-semibold fs-16">Photo Identification</span>
          <i className="bi bi-check-lg fs-28 me-2 text-success float-end" />
        </div>
        <p className="mb-0">
          Photo ID has been uploaded and currently in review.
        </p>
      </div>
      <div className="alert alert-light">
        <div className="mb-2">
          <span className="fw-semibold fs-16">Income & Employment Documents</span>
          <i className="bi bi-exclamation-triangle fs-28 me-2 text-danger float-end" />
        </div>
        <p className="mb-0">
          Income and employment documents are currently in review.
        </p>
      </div>
      <div className="alert alert-light">
        <div className="mb-2">
          <span className="fw-semibold fs-16">Bank Statments</span>
          <i className="bi bi-exclamation-triangle fs-28 me-2 text-danger float-end" />
        </div>
        <p className="mb-0">Bank statements have not yet been provided.</p>
      </div>
    </div>
  );
};



const MessagesTab = () => {
  return <div></div>;
};

ApplicationInfoCard.propTypes = {};

export default ApplicationInfoCard;
